import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    // Element that shows tooltip when hovered over
    const agent = this.element

    // Add delay to hiding tooltip to allow user to go to the tooltip
    $(agent).attr('data-delay', '{ "hide":"150" }')

    $(agent).on('inserted.bs.tooltip', function () {
      $(this).data('bs.tooltip').$tip.hover(
        // When mouse enters tooltip, prevent tooltip from disappearing
        function() {
          $(agent).on('hide.bs.tooltip', function (event) {
            event.preventDefault();
          })
        // When mouse leaves the tooltip, remove the hover event listener and hide the tooltip
        }, function() {
          $(agent).off('inserted.bs.tooltip hide.bs.tooltip')
          // Don't hide tooltip if we hover onto agent
          if (!agent.matches(':hover')) {
            $(agent).tooltip('hide')
          }
        }
      )
    })

    // Close tooltip when escape key is pressed
    $(document).on('keydown', function(event) {
      if (event.key === 'Escape') {
        $(agent).tooltip('hide')
      }
    });
  }
}